import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Crianza Feliz';
render(<App data-id="element-25" />, document.getElementById('root'));